<div class="row g-3">

  <!-- Conversation list: always on lg+, alone below it until a conversation is picked. -->
  <div class="col-12 col-lg-4 d-lg-block" [class.d-none]="selectedStudentId">

    <div class="message-card p-2 p-md-3 mb-3" [formGroup]="fg">
      <app-gray-text-input
        [placeholder]="'messages.search_placeholder'|translate"
        formControlName="search"></app-gray-text-input>

      <app-gray-checkbox class="d-block mt-2" formControlName="onlyUnread">
        <span class="fs-small fw-500 color-gray-700">{{'messages.only_unread'|translate}}</span>
      </app-gray-checkbox>
    </div>

    <ngx-skeleton-loader
      *ngIf="isLoading && !conversations.length" count="5" appearance="line"
      [theme]="{height: '72px', 'border-radius': '16px', margin: '0 0 8px 0'}"/>

    <div class="message-card p-4 text-center" *ngIf="!conversations.length && !isLoading">
      <p class="fs-normal fw-800 color-gray-950 mb-1">{{'messages.empty_title'|translate}}</p>
      <p class="fs-small fw-400 color-gray-500 mb-0">{{'messages.empty_desc'|translate}}</p>
    </div>

    <div class="message-card conversation-row d-flex align-items-center p-3 mb-2 clickable"
         *ngFor="let row of conversations"
         [class.selected]="row.student.id === selectedStudentId"
         [class.unread]="row.unreadCount > 0"
         (click)="openConversation(row)">

      <coach-student-avatar class="me-3" [name]="row.student.name"></coach-student-avatar>

      <div class="flex-grow-1 overflow-hidden">
        <div class="d-flex align-items-center justify-content-between">
          <p class="fs-normal color-gray-950 mb-0 text-truncate"
             [class.fw-800]="row.unreadCount > 0" [class.fw-500]="!row.unreadCount">{{row.student.name}}</p>
          <span class="fs-xsmall fw-500 color-gray-500 ms-2 text-nowrap">{{timeLabel(row.lastMessageAt)}}</span>
        </div>

        <div class="d-flex align-items-center justify-content-between">
          <p class="fs-small mb-0 text-truncate"
             [class.fw-800]="row.unreadCount > 0" [class.color-gray-700]="row.unreadCount > 0"
             [class.fw-400]="!row.unreadCount" [class.color-gray-500]="!row.unreadCount">
            <ng-container *ngIf="row.lastMessage; else noMessage">
              <span *ngIf="isOwnLastMessage(row)">{{'messages.you_prefix'|translate}}</span>{{row.lastMessage.body}}
            </ng-container>
            <ng-template #noMessage>{{'messages.no_messages_yet'|translate}}</ng-template>
          </p>
          <span *ngIf="row.unreadCount > 0"
                class="unread-badge ms-2 bg-red-500 color-gray-50 fs-xsmall fw-800"
                [attr.aria-label]="'messages.unread_badge'|translate: {count: row.unreadCount}">
            {{badgeLabel(row.unreadCount)}}
          </span>
        </div>
      </div>
    </div>

    <app-gray-button
      class="d-block mt-3" *ngIf="hasMore()"
      color="stroke" [weight]="500" padding="py-2" customClass="fs-small"
      [isLoading]="isLoading" [disabled]="isLoading"
      [text]="'messages.load_more'|translate" (click)="loadMore()"></app-gray-button>
  </div>

  <!-- Conversation: always on lg+, alone below it once a conversation is picked. -->
  <div class="col-12 col-lg-8 d-lg-block" [class.d-none]="!selectedStudentId">

    <ng-container *ngIf="selectedStudentId; else noSelection">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <app-gray-button
          class="d-lg-none" color="stroke-transparent" [fullWidth]="false" [weight]="500" padding="py-1 px-2"
          customClass="fs-small" preIcon="arrow-left"
          [text]="'messages.back_to_list'|translate" (click)="backToList()"></app-gray-button>

        <a class="fs-small fw-500 color-gray-700 ms-auto clickable"
           [routerLink]="['/dashboard/students', selectedStudentId]">
          {{'messages.go_to_profile'|translate}}<i class="bi bi-chevron-right ms-1"></i>
        </a>
      </div>

      <coach-messages-tab
        [studentId]="selectedStudentId"
        [studentName]="selectedName()"
        (unreadChanged)="onUnreadChanged($event)"></coach-messages-tab>
    </ng-container>

    <ng-template #noSelection>
      <div class="message-card p-5 text-center">
        <i class="bi bi-chat-dots fs-title color-gray-300"></i>
        <p class="fs-normal fw-800 color-gray-950 mb-1 mt-2">{{'messages.select_title'|translate}}</p>
        <p class="fs-small fw-400 color-gray-500 mb-0">{{'messages.select_desc'|translate}}</p>
      </div>
    </ng-template>
  </div>

</div>
